import { useTestCaseContext } from '@Context/TestCaseContext';
import { XSquare } from '@phosphor-icons/react';
import React, { useEffect } from 'react';

interface SidePanelProps {
  children: React.ReactNode;
  position?: 'left' | 'right';
}

const SidePanel: React.FC<SidePanelProps> = ({
  children,
  position = 'right',
}) => {
  const { panelOpen, setPanelOpen, setSelectedProject, setSelectedSection } =
    useTestCaseContext();

  //* Clear selected project and section when panel is closed either thru the button or overlay
  useEffect(() => {
    if (!panelOpen) {
      setSelectedProject(null);
      setSelectedSection(null);
    }
  }, [panelOpen]);

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity ${
          panelOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={() => {
          setPanelOpen(false);
        }}
      />

      {/* Panel */}
      <div
        className={`fixed top-0 ${
          position === 'right' ? 'right-0' : 'left-0'
        } z-50 h-full w-full transform border-primary-600 bg-white shadow-lg transition-transform md:w-4/5 md:rounded-l-lg md:border-l-8 ${
          panelOpen
            ? 'translate-x-0'
            : position === 'right'
              ? 'translate-x-full'
              : '-translate-x-full'
        }`}
      >
        <button
          className="absolute right-4 top-4 z-50 text-gray-600 hover:text-brandRed-500"
          onClick={() => setPanelOpen(false)}
        >
          <XSquare size={35} weight="fill" />
        </button>
        <div className="h-full w-full">{children}</div>
      </div>
    </>
  );
};

export default SidePanel;
